import styled from 'styled-components';

import { Flex } from 'dash-ui';

export const PaymentMethodsSectionContainer = styled(Flex)`
  width: 100%;
`;
